"use strict";

var __importDefault = void 0 && (void 0).__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var prop_types_1 = __importDefault(require("prop-types"));

var react_1 = __importDefault(require("react"));

var utils_1 = require("../../utils");

require("./style.scss");
/**
* Styled Pipe text separator.
*/


var Pipe = function Pipe(_a) {
  var color = _a.color,
      type = _a.type;
  var classes = (0, utils_1.classList)('story-pipe', "story-pipe-" + type);
  var style = {
    color: color
  };
  return react_1.default.createElement("div", {
    className: classes,
    style: style
  }, "|");
};

Pipe.propTypes = {
  /** The color of the `Pipe` separator */
  color: prop_types_1.default.string,

  /** Specify the thickness of the `Pipe` separator */
  type: prop_types_1.default.oneOf(['normal', 'thin', 'thick'])
};
Pipe.defaultProps = {
  color: undefined,
  type: 'normal'
};
exports.default = Pipe;